import IPasswordLinkResult from './IPasswordLinkResult';

/**
 * What happened to the agent's new way in, from the operator's point of view.
 *
 * - 'email-sent'  the link was mailed; the agent already has it.
 * - 'show-link'   no email, but we hold the link and must hand it over.
 * - 'no-way-in'   neither. The old link has been cancelled and nothing replaced it.
 */
export type PasswordLinkOutcome = 'email-sent' | 'show-link' | 'no-way-in';

export function getPasswordLinkOutcome(
    result: IPasswordLinkResult | null | undefined
): PasswordLinkOutcome {
    if (!result) {
        return 'no-way-in';
    }

    if (result.mailSent) {
        return 'email-sent';
    }

    if (result.passwordLink) {
        return 'show-link';
    }

    return 'no-way-in';
}

export function getMailedToAddress(
    result: IPasswordLinkResult | null | undefined
): string {
    if (!result || !result.mailSent || !result.mailedTo) {
        return '';
    }

    return result.mailedTo;
}

export default getPasswordLinkOutcome;
